import { asString, loadedDefinedMap, loadedDefinedMapWithDefault } from "common/components/component-helpers";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { TextSize } from "component-utils/text-types";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import AvatarOverlayView from "../ui/views/avatar-overlay/avatar-overlay-view";

export const AvatarOverlayMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[imagePV, captionPV, textSizePV], [imageVP]] = useForceValueProducers(getValueProducers, force, ctx);
    const text = loadedDefinedMap(captionPV, asString);
    // eslint-disable-next-line prefer-const
    let image = loadedDefinedMap(imagePV, asString);
    const textSize = loadedDefinedMapWithDefault(textSizePV, TextSize.Medium, asString) as TextSize;

    /* 
        This might look uncommon, but for fixing https://github.com/quicktype/glide/issues/12416 
        we're adding a placeholder to the Avatar only if it's bound to a property, and it has an empty value.
        By using the string PLACEHOLDER, out Img component will show an alternate element that acts as a placeholder

        An alternative, "cleaner"  implementation means more work and no real benefits.
    */
    if (imageVP !== undefined && image === undefined) {
        image = "PLACEHOLDER"
    }

    if (text === undefined && image === undefined) return null;

    return <AvatarOverlayView image={image} text={text} textSize={textSize} appID={env.appEnvironment.appID} />;
};
